export default function useReorderQuestions(){

    return (questions) => {
        
        let newQuestions = [...questions]
            .sort((a,b) => a.rank - b.rank)
            .map((c,i) => {
                return {...c, rank: i + 1}
            })
        
        return newQuestions;
    }
}